module.exports = __webpack_public_path__ + "static/img/lishui-user.85b1b269.png";